//
// Slider (Schwerpunkte)
//

import Swiper, { Navigation} from 'swiper';
Swiper.use([Navigation]);

new Swiper ('.hero-slider-schwerpunkte', {
    navigation: {
        nextEl: '.swiper-navigation-button-next',
        prevEl: '.swiper-navigation-button-prev',
        disabledClass: 'swiper-navigation-button-disabled',
    },
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    loopAdditionalSlides: 3,

    breakpoints: {
        '992': {
            slidesPerView: 1,
            spaceBetween: 40,
        },
    },
});

export default {};
